module.exports = __webpack_public_path__ + "img/vuejs.4a35cc24.png";